(function () {
  var configEl = document.getElementById('EbuyConfig');
  var config = {};
  try {
    config = configEl ? JSON.parse(configEl.textContent) : {};
  } catch (error) {
    config = {};
  }
  window.EbuyTheme = config;

  document.documentElement.classList.remove('no-js');
  document.documentElement.classList.add('js');

  var lastFocus = null;
  var openDialog = null;

  function focusable(root) {
    return Array.prototype.slice.call(root.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')).filter(function (node) {
      return !node.closest('[hidden]') && node.offsetParent !== null;
    });
  }

  function closeDialog(dialog) {
    if (!dialog || dialog.hidden) return;
    dialog.hidden = true;
    dialog.classList.remove('is-open');
    document.body.classList.remove('drawer-open');
    document.removeEventListener('keydown', onDialogKey);
    if (openDialog === dialog) openDialog = null;
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
  }

  function onDialogKey(event) {
    if (!openDialog) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      closeDialog(openDialog);
      return;
    }
    if (event.key !== 'Tab') return;
    var items = focusable(openDialog);
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function openDialogEl(dialog) {
    if (!dialog) return;
    if (openDialog && openDialog !== dialog) closeDialog(openDialog);
    lastFocus = document.activeElement;
    dialog.hidden = false;
    dialog.classList.add('is-open');
    document.body.classList.add('drawer-open');
    openDialog = dialog;
    document.addEventListener('keydown', onDialogKey);
    var target = dialog.querySelector('[data-initial-focus]') || focusable(dialog)[0];
    if (target) target.focus();
  }

  window.EbuyDialog = {
    open: openDialogEl,
    close: closeDialog
  };

  document.querySelectorAll('[data-open-dialog]').forEach(function (button) {
    button.addEventListener('click', function () {
      var dialog = document.getElementById(button.getAttribute('data-open-dialog'));
      if (!dialog) return;
      if (dialog.hidden) openDialogEl(dialog);
      else closeDialog(dialog);
    });
  });

  document.querySelectorAll('[data-dialog]').forEach(function (dialog) {
    dialog.querySelectorAll('[data-dialog-close]').forEach(function (button) {
      button.addEventListener('click', function () {
        closeDialog(dialog);
      });
    });
  });

  var announcement = document.querySelector('[data-announcement]');
  if (announcement) {
    var token = announcement.getAttribute('data-token') || '';
    try {
      if (token && sessionStorage.getItem('ebuy_announcement') === token) {
        announcement.remove();
      }
    } catch (error) {
      token = '';
    }
    var dismiss = announcement.querySelector('[data-dismiss-announcement]');
    if (dismiss) {
      dismiss.addEventListener('click', function () {
        try {
          sessionStorage.setItem('ebuy_announcement', token);
        } catch (error) {
          /* session storage can be unavailable */
        }
        announcement.remove();
      });
    }
  }

  var megaFixedPanels = window.matchMedia('(max-width: 1199px)');

  function closeMegaPanels(except) {
    document.querySelectorAll('.mega [data-submenu-toggle][aria-expanded="true"]').forEach(function (button) {
      if (button === except) return;
      var panel = document.getElementById(button.getAttribute('aria-controls'));
      button.setAttribute('aria-expanded', 'false');
      if (panel) panel.hidden = true;
    });
  }

  document.querySelectorAll('[data-submenu-toggle]').forEach(function (button) {
    button.addEventListener('click', function () {
      var panel = document.getElementById(button.getAttribute('aria-controls'));
      if (!panel) return;
      var expanded = button.getAttribute('aria-expanded') === 'true';
      var inMega = !!button.closest('.mega');
      if (inMega) closeMegaPanels(button);
      button.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      panel.hidden = expanded;
      if (!expanded && inMega) {
        if (megaFixedPanels.matches) {
          var rect = button.getBoundingClientRect();
          panel.style.top = rect.bottom + 'px';
          panel.style.left = Math.max(8, Math.min(rect.left, window.innerWidth - panel.offsetWidth - 8)) + 'px';
        } else {
          panel.style.top = '';
          panel.style.left = '';
        }
      }
    });
  });

  document.addEventListener('click', function (event) {
    if (!event.target.closest('.mega__item')) closeMegaPanels();
  });
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeMegaPanels();
  });
  window.addEventListener('scroll', function () {
    if (megaFixedPanels.matches) closeMegaPanels();
  }, { passive: true });

  var filters = document.querySelector('[data-filters]');
  var filtersOpen = document.querySelector('[data-filters-open]');
  var mobileFilters = window.matchMedia('(max-width: 749px)');

  function closeFilters() {
    if (!filters) return;
    filters.classList.remove('is-open');
    document.body.classList.remove('filters-open');
    if (filtersOpen) filtersOpen.setAttribute('aria-expanded', 'false');
    if (mobileFilters.matches && filtersOpen) filtersOpen.focus();
  }

  if (filters && filtersOpen) {
    filtersOpen.setAttribute('aria-expanded', 'false');
    filtersOpen.addEventListener('click', function () {
      filters.classList.add('is-open');
      document.body.classList.add('filters-open');
      filtersOpen.setAttribute('aria-expanded', 'true');
      var closeBtn = filters.querySelector('button.filters__close');
      if (closeBtn) closeBtn.focus();
    });
    filters.querySelectorAll('[data-filters-close]').forEach(function (button) {
      button.addEventListener('click', closeFilters);
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && filters.classList.contains('is-open') && mobileFilters.matches) {
        closeFilters();
      }
    });
  }

  var sortForm = document.querySelector('[data-sort-form]');
  if (sortForm) {
    var sortSelect = sortForm.querySelector('select');
    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        sortForm.submit();
      });
    }
  }

  document.querySelectorAll('[data-filter-form] input[type="checkbox"]').forEach(function (input) {
    input.addEventListener('change', function () {
      var form = input.form;
      if (form) form.submit();
    });
  });

  function readRecent() {
    try {
      var parsed = JSON.parse(sessionStorage.getItem('ebuy_recent_handles') || '[]');
      if (!Array.isArray(parsed)) return [];
      return parsed.filter(function (handle) {
        return typeof handle === 'string' && /^[a-z0-9-]+$/i.test(handle);
      }).slice(0, 8);
    } catch (error) {
      return [];
    }
  }

  var productHandle = document.body.getAttribute('data-product-handle');
  if (productHandle && config.recentlyViewed) {
    try {
      var next = [productHandle].concat(readRecent().filter(function (handle) {
        return handle !== productHandle;
      })).slice(0, 8);
      sessionStorage.setItem('ebuy_recent_handles', JSON.stringify(next));
    } catch (error) {
      /* ignore */
    }
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-clear-recent]');
    if (!button || button.closest('[data-recently-viewed]')) return;
    try {
      sessionStorage.removeItem('ebuy_recent_handles');
    } catch (error) {
      return;
    }
    var status = document.querySelector('[data-recent-status]');
    if (status) status.textContent = config.strings && config.strings.recentCleared ? config.strings.recentCleared : '';
  });

  document.querySelectorAll('[data-recently-viewed]').forEach(function (section) {
    var grid = section.querySelector('[data-recent-grid]');
    var current = section.getAttribute('data-current') || '';
    var handles = readRecent().filter(function (handle) {
      return handle !== current;
    }).slice(0, 4);
    var clearButton = section.querySelector('[data-clear-recent]');
    if (clearButton) {
      clearButton.addEventListener('click', function () {
        try {
          sessionStorage.removeItem('ebuy_recent_handles');
        } catch (error) {
          /* ignore */
        }
        if (grid) grid.replaceChildren();
        section.hidden = true;
        var live = section.querySelector('[data-recent-status]');
        if (live) live.textContent = config.strings && config.strings.recentCleared ? config.strings.recentCleared : 'Recently viewed products were cleared from this session.';
      });
    }
    if (!grid || !handles.length || !config.recentlyViewed) return;

    Promise.all(handles.map(function (handle) {
      var root = (config.routes && config.routes.root) || '/';
      if (root.slice(-1) !== '/') root += '/';
      return fetch(root + 'products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (response) {
          if (!response.ok) return null;
          return response.json();
        })
        .catch(function () {
          return null;
        });
    })).then(function (products) {
      products.filter(Boolean).forEach(function (product) {
        grid.appendChild(renderRecentCard(product));
      });
      if (grid.children.length) section.hidden = false;
    });
  });

  function money(cents) {
    if (!window.EbuyCart || !window.EbuyCart.formatMoney) return '';
    return window.EbuyCart.formatMoney(cents);
  }

  function renderRecentCard(product) {
    var article = document.createElement('article');
    article.className = 'card';
    var link = document.createElement('a');
    link.className = 'card__media';
    link.href = product.url;
    if (product.featured_image) {
      var img = document.createElement('img');
      img.src = product.featured_image;
      img.alt = product.title || '';
      img.width = 400;
      img.height = 400;
      img.loading = 'lazy';
      link.appendChild(img);
    }
    var title = document.createElement('p');
    title.className = 'card__title';
    var titleLink = document.createElement('a');
    titleLink.href = product.url;
    titleLink.textContent = product.title || '';
    title.appendChild(titleLink);
    var price = document.createElement('p');
    price.className = 'price';
    var current = document.createElement('span');
    current.className = 'price__current';
    current.textContent = money(product.price);
    price.appendChild(current);
    article.appendChild(link);
    article.appendChild(title);
    article.appendChild(price);
    return article;
  }
})();
